/* eslint-disable */
export default {
  title: 'Responder com msg de voz',
  customMessage: 'Mensagem personalizada',
  customMessagePlaceholder: 'Escreva uma mensagem personalizada',
} as const;

// @key: @#@"title"@#@ @source: @#@"Reply with Voice Message"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom message"@#@
// @key: @#@"customMessagePlaceholder"@#@ @source: @#@"Type a custom message"@#@
